import styled from 'styled-components';

export const Item = styled.div<{ $width?: string; $flex?: string }>`
  padding-right: 12px;
  flex: ${({ $flex }) => $flex ?? 'unset'};
  width: ${({ $width }) => $width ?? 'unset'};

  &.image-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  [class*='Controls'] {
    padding: 2px !important;
  }
`;

export const Label = styled.span`
  color: ${({ theme }) => theme.labelColor};
  font-weight: 700;
`;

export const Description = styled.span`
  color: ${({ theme }) => theme.descriptionColor};

  &:nth-of-type(2) {
    margin-left: 8px;
  }
`;
